window.dpdParcelShopPopup = (function () {
	var popupSelector,
		popup,
		popupFormSelector,
		popupForm,
		popupCloseBtnSelector,
		popupContainerSelector,
		popupInputCitySelector,
		popupInputZipSelector,
		popupInputCountrySelector,
		popupInputCity,
		popupInputZip,
		popupInputCountry,
		popupParcelsListSelector,
		popupParcelsList,
		popupParcelsListItemSelector,
		popupResponseSelector,
		popupResponse,
		popupSearchBtnSelector,
		popupSearchBtn,
		popupResultsSelector,
		popupResults,
		popupOpenBtnSelector,
		popupChooseParcelshopBtnSelector,
		chosenParcelShopContentSelector,
		chosenParcelShopContentTextSelector,
		chosenParcelShopHiddenParcelIdSelector,
		chosenParcelShopHiddenParcelPusIdSelector,
		chosenParcelShopHiddenParcelNameSelector,
		chosenParcelShopHiddenParcelStreetSelector,
		chosenParcelShopHiddenParcelCitySelector,
		chosenParcelShopHiddenParcelZipSelector,
		chosenParcelShopHiddenParcelCountryCodeSelector;

	function init() {
		popupSelector = '.js-dpd-parcelshop-popup';
		popupFormSelector = '.js-dpd-parcelshop-popup-form';
		popupCloseBtnSelector = '.js-dpd-parcelshop-popup-close-btn';
		popupContainerSelector = '.js-dpd-parcelshop-popup-container';
		popupInputCitySelector = '.js-dpd-parcelshop-popup-input-city';
		popupInputZipSelector = '.js-dpd-parcelshop-popup-input-zip';
		popupInputCountrySelector = '.js-dpd-parcelshop-popup-input-country';
		popupParcelsListSelector = '.js-dpd-parcelshop-popup-parcels-list';
		popupParcelsListItemSelector = '.js-dpd-parcelshop-popup-parcels-list li';
		popupResponseSelector = '.js-dpd-parcelshop-popup-response';
		popupSearchBtnSelector = '.js-dpd-parcelshop-popup-search-btn';
		popupResultsSelector = '.js-dpd-parcelshop-popup-results';
		popupOpenBtnSelector = '.js-dpd-parcelshop-open-popup-btn';
		popupChooseParcelshopBtnSelector =
			'.js-dpd-parcelshop-popup-choose-parcelshop-btn';
		chosenParcelShopContentSelector = '.js-dpd-chosen-parcelshop-content';
		chosenParcelShopContentTextSelector =
			'.js-dpd-chosen-parcelshop-chosen-parcelshop-text';
		chosenParcelShopHiddenParcelIdSelector =
			'.js-dpd-parcelshop-hidden-parcelshop-id';
		chosenParcelShopHiddenParcelPusIdSelector =
			'.js-dpd-parcelshop-hidden-parcelshop-pus-id';
		chosenParcelShopHiddenParcelNameSelector =
			'.js-dpd-parcelshop-hidden-parcelshop-name';
		chosenParcelShopHiddenParcelStreetSelector =
			'.js-dpd-parcelshop-hidden-parcelshop-street';
		chosenParcelShopHiddenParcelCitySelector =
			'.js-dpd-parcelshop-hidden-parcelshop-city';
		chosenParcelShopHiddenParcelZipSelector =
			'.js-dpd-parcelshop-hidden-parcelshop-zip';
		chosenParcelShopHiddenParcelCountryCodeSelector =
			'.js-dpd-parcelshop-hidden-parcelshop-country-code';

		popup = document.querySelector(popupSelector);
		popupForm = popup.querySelector(popupFormSelector);
		popupInputCity = document.querySelector(popupInputCitySelector);
		popupInputZip = document.querySelector(popupInputZipSelector);
		popupInputCountry = document.querySelector(popupInputCountrySelector);
		popupParcelsList = document.querySelector(popupParcelsListSelector);
		popupResponse = document.querySelector(popupResponseSelector);
		popupSearchBtn = document.querySelector(popupSearchBtnSelector);
		popupResults = document.querySelector(popupResultsSelector);

		document.addEventListener(
			'submit',
			function (event) {
				if (!event.target.matches(popupFormSelector)) {
					return;
				}

				event.preventDefault();

				triggerSearchParcelshops();
			},
			false
		);

		document.addEventListener(
			'click',
			function (event) {
				if (!event.target.matches(popupOpenBtnSelector)) {
					return;
				}

				event.preventDefault();

				openPopup();
			},
			false
		);

		document.addEventListener(
			'click',
			function (event) {
				if (
					!event.target.matches(popupCloseBtnSelector) &&
					!event.target.matches(popupContainerSelector)
				) {
					return;
				}

				event.preventDefault();

				closePopup();
			},
			false
		);

		document.addEventListener(
			'keydown',
			function (event) {
				if (event.key !== 'Escape') {
					return;
				}

				closePopup();
			},
			false
		);

		document.addEventListener(
			'click',
			function (event) {
				if (!event.target.matches(popupChooseParcelshopBtnSelector)) {
					return;
				}

				event.preventDefault();

				chooseParcelShop();
			},
			false
		);

		document.addEventListener(
			'click',
			function (event) {
				if (!event.target.matches(popupParcelsListItemSelector)) {
					return;
				}

				event.preventDefault();

				var previousActiveItem = document.querySelector(
					popupParcelsListItemSelector + '.active'
				);

				if (previousActiveItem) {
					previousActiveItem.classList.remove('active');
				}

				event.target.classList.add('active');
			},
			false
		);
	}

	function getSelectedParcel() {
		return document.querySelector(popupParcelsListItemSelector + '.active');
	}

	function setSelectedParcelShop(selectedParcelShopEl = null) {
		if (!selectedParcelShopEl) {
			selectedParcelShopEl = getSelectedParcel();
		}

		if (!selectedParcelShopEl) {
			return;
		}

		var parcelShopId = selectedParcelShopEl.getAttribute('data-id');
		var parcelShopPusId = selectedParcelShopEl.getAttribute('data-pus-id');
		var parcelShopName = selectedParcelShopEl.getAttribute('data-name');
		var parcelShopStreet = selectedParcelShopEl.getAttribute('data-street');
		var parcelShopZip = selectedParcelShopEl.getAttribute('data-zip');
		var parcelShopCity = selectedParcelShopEl.getAttribute('data-city');
		var parcelShopCountryCode =
			selectedParcelShopEl.getAttribute('data-country-code');

		// Update session
		setSelectedParcelShopSession(
			parcelShopId,
			parcelShopPusId,
			parcelShopName,
			parcelShopStreet,
			parcelShopZip,
			parcelShopCity,
			parcelShopCountryCode
		);

		// Update frontend field
		document.querySelector(chosenParcelShopHiddenParcelIdSelector).value =
			parcelShopId;
		document.querySelector(chosenParcelShopHiddenParcelPusIdSelector).value =
			parcelShopPusId;
		document.querySelector(chosenParcelShopHiddenParcelNameSelector).value =
			parcelShopName;
		document.querySelector(chosenParcelShopHiddenParcelStreetSelector).value =
			parcelShopStreet;
		document.querySelector(chosenParcelShopHiddenParcelZipSelector).value =
			parcelShopZip;
		document.querySelector(chosenParcelShopHiddenParcelCitySelector).value =
			parcelShopCity;
		document.querySelector(
			chosenParcelShopHiddenParcelCountryCodeSelector
		).value = parcelShopCountryCode;

		document.querySelector(chosenParcelShopContentTextSelector).innerHTML =
			selectedParcelShopEl.innerHTML;
		document
			.querySelector(chosenParcelShopContentSelector)
			.classList.add('active');
	}

	function setSelectedParcelShopSession(
		parcelShopId = '',
		parcelShopPusId = '',
		parcelShopName = '',
		parcelShopStreet = '',
		parcelShopZip = '',
		parcelShopCity = '',
		parcelShopCountryCode = ''
	) {
		// Prepare XHR Request.
		var xhr = new XMLHttpRequest();
		xhr.open('POST', wc_dpd_parcelshop_popup_settings.ajax_url, true);
		xhr.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');

		// Callback on response.
		xhr.onreadystatechange = function () {
			// readyState 4 means the request is done.
			var DONE = 4;

			// status 200 is a successful return.
			var OK = 200;

			// Check response.
			if (xhr.readyState === DONE) {
				if (xhr.status === OK) {
					document.body.dispatchEvent(new Event('update_checkout'));
				}
			}
		};

		// Finally do the call with the right parametetrs.
		xhr.send(
			'action=wc_dpd_update_chosen_parcelshop&wp_nonce=' +
				popupForm.getAttribute('data-nonce') +
				'&wc_dpd_parcelshop_id=' +
				parcelShopId +
				'&wc_dpd_parcelshop_pus_id=' +
				parcelShopPusId +
				'&wc_dpd_parcelshop_name=' +
				parcelShopName +
				'&wc_dpd_parcelshop_street=' +
				parcelShopStreet +
				'&wc_dpd_parcelshop_zip=' +
				parcelShopZip +
				'&wc_dpd_parcelshop_city=' +
				parcelShopCity +
				'&wc_dpd_parcelshop_country_code=' +
				parcelShopCountryCode
		);
	}

	function chooseParcelShop() {
		clearErrorMessages();

		var selectedParcelShop = getSelectedParcel();

		if (!selectedParcelShop) {
			setErrorMessage(
				wc_dpd_parcelshop_popup_settings.select_parcelshop_error_message
			);

			return;
		}

		setSelectedParcelShop(selectedParcelShop);

		closePopup();
	}

	function maybeMatchSelectedParcelshop() {
		if (getSelectedParcel()) {
			return;
		}

		var selectedParcelId = document.querySelector(
			chosenParcelShopHiddenParcelIdSelector
		).value;

		if (!selectedParcelId) {
			return;
		}

		var parcelShopEl = document.querySelector(
			popupParcelsListItemSelector + '[data-id="' + selectedParcelId + '"]'
		);

		if (!parcelShopEl) {
			return;
		}

		parcelShopEl.classList.add('active');
	}

	function openPopup() {
		clearErrorMessages();

		maybeMatchSelectedParcelshop();

		popup.classList.add('active');
	}

	function closePopup() {
		popup.classList.remove('active');
	}

	function showResults() {
		popupResults.classList.add('active');
	}

	function hideResults() {
		popupResults.classList.remove('active');
	}

	function clearPopupParcels() {
		popupParcelsList.innerHTML = '';
	}

	function resetPopupParcels() {
		hideResults();
		clearPopupParcels();
	}

	function setPopupParcelsList(html) {
		popupParcelsList.innerHTML = html;

		showResults();
	}

	function clearErrorMessages() {
		popupResponse.innerHTML = '';
		popupResponse.classList.remove('active');
	}

	function setErrorMessage(error) {
		popupResponse.innerHTML = '<p>' + error + '</p>';
		popupResponse.classList.add('active');
	}

	function searchParcelShop(city, zip, country) {
		// Prepare XHR Request.
		var xhr = new XMLHttpRequest();
		xhr.open('POST', wc_dpd_parcelshop_popup_settings.ajax_url, true);
		xhr.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');

		popupSearchBtn.classList.add('loading');

		resetPopupParcels();

		// Callback on response.
		xhr.onreadystatechange = function () {
			// readyState 4 means the request is done.
			var DONE = 4;

			// status 200 is a successful return.
			var OK = 200;

			// Check response.
			if (xhr.readyState === DONE) {
				popupSearchBtn.classList.remove('loading');
				let json = JSON.parse(xhr.responseText);

				if (xhr.status === OK) {
					// Exist if not success.
					if (!json.success) {
						setErrorMessage(json.data.message);
					} else {
						// Success, display results

						if (json.data.hasOwnProperty('parcelshops')) {
							var parcelshops = json.data.parcelshops;
							var parcelshopsHtml = '';

							for (var key in parcelshops) {
								var id = parcelshops[key].hasOwnProperty('id')
									? parcelshops[key].id
									: '';

								var pusId = parcelshops[key].hasOwnProperty('pusId')
									? parcelshops[key].pusId
									: '';

								// Skip parcelshops without ID
								if (!id || !pusId) {
									continue;
								}

								var name = parcelshops[key].hasOwnProperty('name')
									? parcelshops[key].name
									: '';
								var street = parcelshops[key].hasOwnProperty('street')
									? parcelshops[key].street
									: '';
								var zip = parcelshops[key].hasOwnProperty('zip')
									? parcelshops[key].zip
									: '';
								var city = parcelshops[key].hasOwnProperty('city')
									? parcelshops[key].city
									: '';

								var countryCode =
									parcelshops[key].hasOwnProperty('country') &&
									parcelshops[key].country.hasOwnProperty('code')
										? parcelshops[key].country.code
										: '';

								var countryName =
									parcelshops[key].hasOwnProperty('country') &&
									parcelshops[key].country.hasOwnProperty('name')
										? parcelshops[key].country.name
										: '';

								parcelshopsHtml +=
									'<li' +
									' data-id="' +
									id +
									'"' +
									' data-pus-id="' +
									pusId +
									'"' +
									' data-name="' +
									name +
									'"' +
									' data-street="' +
									street +
									'"' +
									' data-zip="' +
									zip +
									'"' +
									' data-city="' +
									city +
									'"' +
									' data-country-code="' +
									countryCode +
									'"' +
									'>' +
									[name, street, zip + ' ' + city, countryName].join(', ') +
									'</li>';
							}

							setPopupParcelsList(parcelshopsHtml);
						}
					}
				} else {
					// Error.
					if (json.data.hasOwnProperty('message')) {
						setErrorMessage(json.data.message);
					}
				}
			}
		};

		// Finally do the call with the right parametetrs.
		xhr.send(
			'action=wc_dpd_parcelshop_search&wp_nonce=' +
				popupForm.getAttribute('data-nonce') +
				'&city=' +
				city +
				'&zip=' +
				zip +
				'&country=' +
				country
		);
	}

	function triggerSearchParcelshops() {
		clearErrorMessages();

		if (popupSearchBtn.classList.contains('loading')) {
			return;
		}

		if (
			!popupInputCity.value ||
			!popupInputZip.value ||
			!popupInputCountry.value
		) {
			setErrorMessage(
				wc_dpd_parcelshop_popup_settings.required_fields_error_message
			);
			return;
		}

		searchParcelShop(
			popupInputCity.value,
			popupInputZip.value,
			popupInputCountry.value
		);
	}

	function docReady(fn) {
		if (
			document.readyState === 'complete' ||
			document.readyState === 'interactive'
		) {
			setTimeout(fn, 1);
		} else {
			document.addEventListener('DOMContentLoaded', fn);
		}
	}

	docReady(function () {
		init();
	});

	return {
		openPopup: openPopup,
		closePopup: closePopup,
		setSelectedParcelShop: setSelectedParcelShop,
		searchParcelShop: searchParcelShop,
		resetPopupParcels: resetPopupParcels,
		triggerSearchParcelshops: triggerSearchParcelshops,
	};
})();
